<script setup lang="ts">
import AdditionalServiceAmount from "~/components/component/Service/AdditionalServiceAmount.vue";

import {scrollToAnchor} from "~/utils/scrollToAnchor";

const props = defineProps({
  childrenServices: {
    type: Array,
    default: () => []
  },
})
const emit = defineEmits(['selected'])

const showAllServices = ref(false)

const visibleServices = computed(() => showAllServices.value ? props.childrenServices : props.childrenServices.slice(0, 5))

function toggleAllServices() {
  showAllServices.value = !showAllServices.value
  if (!showAllServices.value) {
    scrollToAnchor('additional_services')
  }
}
</script>

<template>
  <div class="form_block">
    <p id="additional_services" class="text-[13px] md:text-base font-bold text-[#16211C] mb-1">{{ $t('services.additional_services') }}</p>
    <p class="text-[12px] md:text-sm text-[#8a938e] mb-[13px]">{{ $t('services.additional_services_subtitle') }}</p>

    <div class="border border-[#ECEAE4] rounded-[15px] px-[14px]">
      <AdditionalServiceAmount
          v-for="(service, index) in visibleServices"
          :key="service.service_id"
          :service
          :class="{ 'border-b border-[#F2F1EC]': index !== visibleServices.length - 1 }"
      />
    </div>

    <button
        @click="toggleAllServices"
        class="flex gap-2 items-center text-primary-green mt-3"
    >
      <span v-if="showAllServices" class="text-sm md:text-base font-medium">{{ $t('input_forms.button.show_less') }}</span>
      <span v-else class="text-sm md:text-base font-medium">{{ $t('input_forms.button.show_all_services') }}</span>
      <IconUIChevronUp :class="{ 'rotate-180' : !showAllServices }"/>
    </button>
  </div>
</template>

<style scoped>

</style>
